import React from "react";
import FlightsTable from "./FlightsTable.jsx";

export default function Departures(props) {
  return <FlightsTable {...props} mode="DEPARTURES" />;
}
